import { useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { IconLink } from '@iwoca/icons';
import { Trans } from '@lingui/react/macro';

import { BankSelectionModal } from './BankSelectionModal/BankSelectionModal';
import { TOnlineBank } from './OpenBanking.types';
import styles from './TrueLayer.module.css';
import { useContextStateKey } from '../../../hooks/useContextStateKey';
import { useLocale } from '../../../hooks/useLocale';
import { useGetContext } from '../../../lendingApi/lendingApiQueries';
import { getAmplitudeDefaultEventProperties } from '../../../utils/amplitudeEvents';
import { Button } from '../../Button/Button';

type TProps = {
  disabled?: boolean;
};

const LinkOpenBanking = ({ disabled }: TProps) => {
  const stateKey = useContextStateKey();
  const { isDE } = useLocale();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { context } = useGetContext();

  const getBankList = (): TOnlineBank[] => {
    let truelayerBanks: TOnlineBank[] = [];
    let finapiBanks: TOnlineBank[] = [];
    if (context) {
      if (context.open_banking.truelayer_banks) {
        truelayerBanks = context.open_banking.truelayer_banks.map(
          (bank: TOnlineBank) => ({
            ...bank,
            provider: 'truelayer', //add provider identifier for authURL requeset routing
          }),
        );
      }
      if (context.open_banking.finapi_banks) {
        finapiBanks = context.open_banking.finapi_banks.map(
          (bank: TOnlineBank) => ({
            ...bank,
            provider: 'finapi', //add provider identifier for authURL requeset routing
          }),
        );
      }
    }
    return [...truelayerBanks, ...finapiBanks] as TOnlineBank[];
  };

  const handleClick = () => {
    if (!stateKey) return;

    tracking.ampli.openBankingConnectStarted(
      getAmplitudeDefaultEventProperties(),
    );

    return setIsModalOpen(true);
  };

  const handleBankSelectionClose = () => {
    tracking.ampli.trueLayerModalClosed();
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        className={styles.button}
        variant="secondary"
        onClick={handleClick}
        disabled={disabled || !stateKey}
      >
        <Trans>Link bank account</Trans>
        <IconLink />
      </Button>

      <BankSelectionModal
        isOpen={isModalOpen}
        handleClose={handleBankSelectionClose}
        bankList={getBankList()}
        shouldSkipPermissionView={isDE}
      />
    </>
  );
};

export default LinkOpenBanking;
